import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../Main/reducers/reducers';
import * as Middlewares from './middlewares';

export default createStore(rootReducer, applyMiddleware(Middlewares.logger, thunk));
